/**
 * HOC to apply prop types to a component
 */
export default (propTypes: Record<string, any>) => (Component: any): any => {
  Component.propTypes = propTypes
  return Component
}
